var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsWrapped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26001 11.5199V16.4899C4.26001 18.3099 4.26001 18.3099 5.98001 19.4699L10.71 22.1999C11.42 22.6099 12.58 22.6099 13.29 22.1999L18.02 19.4699C19.74 18.3099 19.74 18.3099 19.74 16.4899V11.5199C19.74 9.69994 19.74 9.69994 18.02 8.53994L13.29 5.80994C12.58 5.39994 11.42 5.39994 10.71 5.80994L5.98001 8.53994C4.26001 9.69994 4.26001 9.69994 4.26001 11.5199Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.13V5.5C17.5 3.5 16.5 2.5 14.5 2.5H9.5C7.5 2.5 6.5 3.5 6.5 5.5V8.06",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.63 11.49L13.2 12.38C13.29 12.52 13.49 12.66 13.64 12.7L14.66 12.96C15.29 13.12 15.46 13.66 15.05 14.16L14.38 14.97C14.28 15.1 14.2 15.33 14.21 15.49L14.27 16.54C14.31 17.19 13.85 17.52 13.25 17.28L12.27 16.89C12.12 16.83 11.87 16.83 11.72 16.89L10.74 17.28C10.14 17.52 9.68002 17.18 9.72002 16.54L9.78002 15.49C9.79002 15.33 9.71002 15.09 9.61002 14.97L8.94002 14.16C8.53002 13.66 8.70002 13.12 9.33002 12.96L10.35 12.7C10.51 12.66 10.71 12.51 10.79 12.38L11.36 11.49C11.72 10.95 12.28 10.95 12.63 11.49Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWrapped);
export default __webpack_public_path__ + "static/media/settings-wrapped.63e52b673e8c3118b31f9f29b39f7e3a.svg";
export { ForwardRef as ReactComponent };